import { initializeApp, FirebaseApp } from 'firebase/app'
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, Auth, connectAuthEmulator } from 'firebase/auth'
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Firebase が設定されているかチェック
const isFirebaseConfigured = 
  firebaseConfig.apiKey && 
  firebaseConfig.apiKey !== 'dummy-api-key' &&
  !firebaseConfig.apiKey.includes('dummy')

// Firebase初期化（設定されている場合のみ）
let app: FirebaseApp | null = null
let db: Firestore | null = null
let auth: Auth | null = null
let storage: FirebaseStorage | null = null

if (isFirebaseConfigured) {
  try {
    app = initializeApp(firebaseConfig)
    db = getFirestore(app)
    auth = getAuth(app)
    storage = getStorage(app)

    // ローカル開発環境（localhost）かつ開発モードの場合、エミュレータに接続
    if (import.meta.env.DEV && window.location.hostname === 'localhost') {
      connectFirestoreEmulator(db, 'localhost', 8080)
      connectAuthEmulator(auth, 'http://localhost:9099')
      connectStorageEmulator(storage, 'localhost', 9199)
      console.log('🔧 Connected to Firebase Emulators')
    }

    console.log('✅ Firebase initialized successfully')
  } catch (error) {
    console.warn('⚠️ Firebase initialization failed:', error)
  }
} else {
  console.warn('⚠️ Firebase not configured. Using demo mode.')
}

export { app, db, auth, storage, isFirebaseConfigured }

